import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { PageWrapper, Loader, Alert } from "../../components";
import Actions, { thunks } from "../../redux/modules/appUsers";
import VersionModal from "./components/versionModal";
import { formatIsoDate } from "../../utils/format";

class Version extends React.Component {

    state = {
        versionToDelete: null,

    };
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(thunks.getVersions());
  }

  addVersion = (body) => {
    const { dispatch } = this.props;
    delete body.versionToDelete
    dispatch(thunks.addVersion(body));
  };

  handleAddversion = () => {
    const { updateProperty } = this.props;
    updateProperty("showModal", true);
  };

  deleteVersion = version => {
    this.setState({ versionToDelete: version });
  };

  handleDeleteVersion = () => {
    const { dispatch } = this.props;
    const { versionToDelete } = this.state;
    dispatch(thunks.deleteVersion(versionToDelete.id));
    this.setState({ versionToDelete: null });
  };

  closeModal = () => {
    const { updateProperty } = this.props;
    updateProperty("showModal", false);
  };

  render() {
    const { list, loading, error, updateProperty, showModal } = this.props;
    const {versionToDelete} = this.state;
    return (
      <PageWrapper title="Version">
        <Loader show={loading} />
        <Alert
          show={!!error}
          onHide={() => updateProperty("error", "")}
          title="Version"
          message={error}
        />
        <div className="animated fadeIn">
          <div className="row mt-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end mb-3">
                      <button
                        className="btn btn-primary"
                        onClick={this.handleAddversion}
                      >
                        <i className="fa fa-plus mr-2" />
                        Add
                      </button>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Created Date</th>
                          <th>Version</th>
                          <th>Platform</th>
                          <th>Force Update</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length ? (
                          list.map((ver) => (
                            <tr key={ver.id}>
                              <td>{ver.id}</td>
                              <td>{formatIsoDate(ver.created_on)}</td>
                              <td>{ver.version}</td>
                              <td>{ver.platform}</td>
                              <td>
                                {ver.force_upgrade ? (
                                  <b className="text-primary">Yes</b>
                                ) : (
                                  <b className="text-danger">No</b>
                                )}
                              </td>
                              <td onClick={()=>this.deleteVersion(ver)}><i className="fa fa-trash text-danger" /></td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <VersionModal
          show={showModal}
          onHide={this.closeModal}
          addVersion={this.addVersion}
        />

        <Alert
          show={!!versionToDelete}
          onHide={() => this.setState({ versionToDelete: null })}
          title="Delete Version"
          message={`Are you sure you want to delete Version ID: ${
            (versionToDelete || {}).id
          }?`}
          onSubmit={this.handleDeleteVersion}
        />
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({
  appUsers: { loading, error, list, nextPageToken, showModal },
}) => ({
  loading,
  error,
  list,
  nextPageToken,
  showModal,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
  reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(Version);
